"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geo = void 0;
exports.geo = {
    geo_title: "Пункт",
    geo_objectType: "Тип площадки",
    geo_objectTypeContainers: "Контейнерная площадка",
    geo_objectTypeStationary: "Стационарный пункт приема",
    geo_objectTypeTemporary: "Акция по сбору вторсырья",
    geo_recycledTypes: "Фракции",
    geo_recycledTypeGlass: "Стекло",
    geo_recycledTypePaper: "Бумага",
    geo_recycledTypePlastic: "Пластик",
    geo_recycledTypeWrap: "Пленка",
    geo_recycledTypeMetall: "Металл",
    geo_recycledTypeDangerous: "Опасные отходы",
    geo_recycledTypeTetrapak: "Тетрапак",
    geo_recycledTypeFood: "Пищевые отходы",
    geo_recycledTypeOther: "Другое",
    geo_recycledTypeBattery: "Батарейки",
    geo_recycledTypeThermometer: "Градусники",
    geo_recycledTypeLamp: "Ртуть содержащие лампы",
    geo_recycledTypeElectronics: "Электроника и аккумуляторы",
    geo_recycledTypeClothes: "Одежда",
    geo_recycledTypeHuge: "Крупногабаритные отходы",
    geo_objectStatus: "Статус объекта",
    geo_objectStatusNew: "Новый",
    geo_objectStatusApproved: "Подтвержден",
    geo_objectStatusRejected: "Отклонен",
    geo_description: "Описание",
    geo_containers: "Количество контейнеров",
    geo_regularContainers: "Обычных контейнеров",
    geo_specialContainers: "Контейнеров	раздельного сбора",
    geo_findNav: "Проложить маршрут",
    geo_appYandexNav: "Яндекс.Навигатор",
    geo_appGoogleMaps: "Карты Google",
    geo_appAppleMaps: "Карты Apple",
    geo_orgContainers: "Владелец",
    geo_orgStationary: "Организация",
    geo_orgTemporary: "Организатор акции",
    geo_datesTitle: "Акция проводится",
    geo_dates: "С {0} по {1}",
    geo_workingHours: "Время работы",
    geo_supportButton: "Сообщить о проблеме",
    geo_imagesOf: "из",
    geo_city: "Населенный пункт",
    geo_cityPlaceholder: "Поиск",
    geo_cityLabel: "Выберете из списка",
};
//# sourceMappingURL=geo.js.map